import styled from 'styled-components';

const TicketInfoTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: black;
`;

export default TicketInfoTitle;
